import { render, staticRenderFns } from "./releaseNoteTable.vue?vue&type=template&id=8a0faaa8"
import script from "./releaseNoteTable.vue?vue&type=script&lang=js"
export * from "./releaseNoteTable.vue?vue&type=script&lang=js"
import style0 from "./releaseNoteTable.vue?vue&type=style&index=0&id=8a0faaa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports